import { useState } from 'react'
import { CircularProgress } from '@mui/material'
import { CollaboratorsModalComponent } from '../CollaboratorsModal'

import { usePeople } from '../../context'
import * as S from './styles.ts'
import { Users } from '@phosphor-icons/react'

interface CollaboratorsSectionComponentProps {
  canEdit?: boolean
}

export const CollaboratorsSectionComponent = ({ canEdit = true }: CollaboratorsSectionComponentProps) => {
  const { 
    collaboratorsTotalData,
    isCollaboratorsTotalLoading
  } = usePeople()

  const [openCollaboratorsModal, setOpenCollaboratorsModal] = useState(false)

  const handleOpenCollaboratorsModal = () => {
    setOpenCollaboratorsModal(true)
  }

  return (
    <>
      <S.CollaboratorsSection>
        <S.CollaboratorsCard>
          <S.CollaboratorsSectionTitle>Colaboradores</S.CollaboratorsSectionTitle>
          <S.CollaboratorsContentRow>
            <S.CollaboratorsHeader>
              <S.CollaboratorsIcon>
                <Users size={40} weight="regular" color="#D96060" />
              </S.CollaboratorsIcon>
              <S.CollaboratorsInfo>
                <S.CollaboratorsTitle>Gestão de Colaboradores</S.CollaboratorsTitle>
                <S.CollaboratorsTotal>
                  <S.CollaboratorsTotalLabel>TOTAL</S.CollaboratorsTotalLabel>
                  <S.CollaboratorsTotalValue>
                    {isCollaboratorsTotalLoading ? (
                      <S.SkeletonTotalValue />
                    ) : (
                      collaboratorsTotalData?.totalEmployees?.toLocaleString('pt-BR') || 0
                    )}
                  </S.CollaboratorsTotalValue>
                </S.CollaboratorsTotal>
              </S.CollaboratorsInfo>
            </S.CollaboratorsHeader>
            <S.CollaboratorsFooter>
              <S.CollaboratorsButton
                variant="contained"
                disabled={isCollaboratorsTotalLoading}
                onClick={handleOpenCollaboratorsModal}
              >
                {isCollaboratorsTotalLoading ? <CircularProgress size={20} /> : 'Ver Gestão Colaboradores'}
              </S.CollaboratorsButton>
            </S.CollaboratorsFooter>
          </S.CollaboratorsContentRow>
        </S.CollaboratorsCard>
      </S.CollaboratorsSection>

      <CollaboratorsModalComponent
        open={openCollaboratorsModal}
        data={null}
        onClose={() => setOpenCollaboratorsModal(false)}
        canEdit={canEdit}
      />
    </>
  )
}
